/**
 * The two publish-wall prerequisites for a `payloadShape: 'transactions'` export
 * destination, as a pure predicate the admin UI can preview live. Mirrors
 * `validateRemittanceConfig` (validate-config.ts) EXACTLY — in particular it reads
 * the destination's OWN `triggerPolicy` (not any inherited job default), because
 * the server does too. Keep the two in lockstep.
 */
export function remittanceDestinationPrereqs(dest, surface) {
    const mode = dest.triggerPolicy?.mode;
    const grouping = dest.triggerPolicy?.grouping;
    return {
        surfaceOk: surface === "remittance",
        policyOk: mode === "accumulate" && grouping === "batch",
    };
}
//# sourceMappingURL=destination-prereqs.js.map